export default class FinanceCompaniesManagementService {
  constructor($http, appConfig) {
    "ngInject";

    this.$http = $http;
    this.appConfig = appConfig;
  }

  addFinanceCompany(financeCompany) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/financecompanies/add`, financeCompany);
  }

  editFinanceCompany(financeCompany) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/financecompanies/edit`, financeCompany);
  }

  listFinanceCompanies(entityId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/financecompanies/list/${entityId}`);
  }

  removeFinanceCompany(entityId, financeCompanyId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/financecompanies/remove/${entityId}/${financeCompanyId}`);
  }
}



// WEBPACK FOOTER //
// ./client/app/components/admin/financeCompaniesManagement/financeCompaniesManagement.service.js